import { GeckoComponentRect } from 'types/geometric/geckoComponentRect'
import { GeckoComponentSpace } from 'types/geometric/geckoComponentSpace'
import { parseNumber } from 'utils/parsingHelpers'

import { GeckoMarkupPrimitive } from './geckoMarkupPrimitive'

/**
 * Markup rects are defined by a start and end point in component space, where
 * wrapping is defined as when the end point is a lower coordinate than the
 * start point (i.e. x_start = 8, x_end = 2)
 */
export class GeckoMarkupRect extends GeckoMarkupPrimitive {
  //----------------------------------------------------------------------------

  public readonly kind = 'rect'
  public readonly rect: GeckoComponentRect

  private constructor(
    id: string,
    markupLayerID: string,
    json: Record<string, unknown>,
    markupBounds: GeckoComponentSpace
  ) {
    const xStart = parseNumber(json.x_start)
    const xEnd = parseNumber(json.x_end)
    const yStart = parseNumber(json.y_start)
    const yEnd = parseNumber(json.y_end)
    if (
      xStart === undefined ||
      xEnd === undefined ||
      yStart === undefined ||
      yEnd === undefined
    )
      throw new Error(`Primitive "${id}" malformed: ${JSON.stringify(json)}`)

    const rect = GeckoComponentRect.CreateFromXYs(
      markupBounds.componentID,
      xStart,
      yStart,
      xEnd,
      yEnd,
      markupBounds.x.unit,
      markupBounds.y.unit
    )
    super(id, markupLayerID, rect)
    this.rect = rect
  }

  //----------------------------------------------------------------------------

  public static CreateFromJSON(
    id: string,
    markupLayerID: string,
    json: Record<string, unknown>,
    markupBounds: GeckoComponentSpace
  ) {
    return new GeckoMarkupRect(id, markupLayerID, json, markupBounds)
  }
}

/**
 * ---------------------------------------------------------------------------------------------------------------------
 *                                                    JSON-Type
 *           Copied from https://geckorobotics.atlassian.net/wiki/spaces/SE/pages/3958603801/Markup+Layer+Schema
 * ---------------------------------------------------------------------------------------------------------------------
 */

export type GeckoMarkupRectJSON = {
  kind: 'rect'
  x_start: number
  y_start: number
  x_end: number
  y_end: number
}
